<template>
  <v-menu open-on-hover top :close-on-content-click="false">
    <v-icon small slot="activator">mdi-information</v-icon>

    <v-card dark max-width="500">
      <v-list>
        <v-list-tile avatar class="mb-2">
          <v-list-tile-avatar size="32">
            <img v-if="document.created_by.avatar.url !== null" :src="document.created_by.avatar.url"/>
            <span v-else>{{ acronym(document.created_by.name) }}</span>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{ startCaseText(document.created_by.name) }}</v-list-tile-title>
            <v-list-tile-sub-title v-if="document.created_by.role">{{ document.created_by.role.name }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-if="document.created_by.administrative_unit">{{
              document.created_by.administrative_unit.abbreviation }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>

        <div class="activity-detail-document-info mt-2 ml-2">
          <!-- <b>Número DocGo:</b> {{ document.docflow_number }} -->
          {{ document.created_by }}
        </div>
      </v-list>
    </v-card>

  </v-menu>
</template>

<script>
import {startCase, lowerCase} from 'lodash';
import acronym from '@/utils/acronym';

export default {
  name: 'DocumentInfo',
  props: {
    document: {}
  },
  data() {
    return {};
  },
  methods: {
    acronym,
    startCaseText(string) {
      return startCase(lowerCase(string));
    },
  }
};
</script>

<style scoped lang="scss">
  .v-avatar{
    background-color: #616161 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/document/list/DocumentInfo.vue